import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { 
  doc,
  getDoc,
  updateDoc,
  writeBatch,
  serverTimestamp
} from "firebase/firestore";

import { db } from "../firebase";

function TedarikciGiderDetay() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [gider, setGider] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPaying, setIsPaying] = useState(false);

  useEffect(() => {
    const fetchGider = async () => {
      try {
        const ref = doc(db, "tedarikciGiderleri", id);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setGider({ id: snap.id, ...snap.data() });
        } else {
          console.log("Gider bulunamadı.");
        }
      } catch (err) {
        console.error("Hata:", err);
      }

      setLoading(false);
    };

    fetchGider();
  }, [id]);

  const handleOdemeTamamla = async () => {
    if (!gider) return;

    try {
      setIsPaying(true);

      const batch = writeBatch(db);

      const giderRef = doc(db, "tedarikciGiderleri", gider.id);

      batch.update(giderRef, {
        durum: "Ödendi",
        odemeTarihi: serverTimestamp()
      });

      await batch.commit();

      alert("Ödeme başarıyla tamamlandı!");
      navigate("/odemeler");

    } catch (err) {
      console.error("Ödeme hatası:", err);
      alert("Ödeme sırasında bir hata oluştu!");
    }

    setIsPaying(false);
  };

  if (loading) {
    return <div className="admin-box">Yükleniyor...</div>;
  }

  if (!gider) {
    return (
      <div className="admin-box">
        <p>Bu gider bulunamadı.</p>
        <button 
          onClick={() => navigate("/odemeler")} 
          className="admin-button-secondary"
        >
          ← Geri Dön
        </button>
      </div>
    );
  }

  return (
    <div className="admin-page">
      
      <div className="admin-header">
        <h2>Tedarikçi Gider Detayı</h2>

        <button 
          onClick={() => navigate("/odemeler")} 
          className="admin-button-secondary"
        >
          ← Geri Dön
        </button>
      </div>

      <div className="admin-box">

        <p><strong>Tedarikçi:</strong> {gider.cariAd}</p>
        <p><strong>Miktar:</strong> ₺{gider.miktar?.toLocaleString("tr-TR")}</p>
        <p><strong>Son Ödeme Günü:</strong> {gider.sonOdemeGunu}</p>
        <p><strong>Durum:</strong> {gider.durum}</p>

        {gider.durum === "Bekliyor" && (
          <button 
            onClick={handleOdemeTamamla}
            className="admin-button"
            disabled={isPaying}
            style={{ marginTop: 15 }}
          >
            {isPaying ? "İşlem Yapılıyor..." : "Ödemeyi Tamamla"}
          </button>
        )}
      </div>
    </div>
  );
}

export default TedarikciGiderDetay;
